import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDocusignRegularIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 31 31",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M20.787 20.766v6.005a.57.57 0 0 1-.57.57H4.433a.57.57 0 0 1-.57-.57v-15.77a.57.57 0 0 1 .57-.571h5.994v9.766c0 .315.254.57.57.57z",
			fill: "#4c00ff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27.363 12.298c0 5.047-2.948 8.456-6.575 8.468V14.41a.66.66 0 0 0-.206-.485l-3.3-3.3a.68.68 0 0 0-.485-.206H10.44V4.425a.57.57 0 0 1 .57-.57h8.892c4.222-.013 7.461 3.384 7.461 8.443",
			fill: "#ff5252"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.582 13.912a.68.68 0 0 1 .206.485v6.357H11.01a.57.57 0 0 1-.57-.57v-9.766h6.357a.66.66 0 0 1 .485.206z",
			fill: "#000"
		})
	]
});
export default SvgDocusignRegularIcon;
